import { fbFunctions } from "../../../config/firebase";
import axios from "axios";

const fb = require('./../../../config/firebase.js')

const state = () => ({
    announcements: {},
    announcementsLoaded: false,
    announcementsAnonymous: {},
    announcementsAnonymousLoaded: false,
})

const getters = {}

const actions = {
    fetchAnnouncements({ commit, state }) {
        let vm = this;
        let randomNumber = Math.floor(Math.random() * 21);
        let userLanguage = navigator.languages[0].split('-')[0];
        if(userLanguage !== "fr" && userLanguage !== "en") userLanguage = "en";
        fb.adsCollection
            .where('is_active', '==', true)
            .where("is_for_web", '==', true)
            .where("language", '==', userLanguage)
            .where("ad_random_id", '>=', randomNumber)
            .limit(1)
            .get()
            .then(function(doc) {
                if(vm.state.user.currentUser.uid != null) {
                    let incrementAdViews = fbFunctions.httpsCallable('api');
                    incrementAdViews({
                        type: 'incrementAdViews',
                        parameters: {
                            'adId': doc.docs[0].id,
                        }
                    });
                }
                doc.forEach((snapshot) => {
                    commit('setAnnouncements', snapshot.data())
                    commit('setAnnouncementsLoaded', true)
                });
            })
            .catch((e) => console.log("Error getting document:", e))
    },
    incrementAdClicks({ commit, state }, payload) {
        if(this.state.user.currentUser.uid != null) {
            let incrementAdClicks = fbFunctions.httpsCallable('api');
            incrementAdClicks({
                type: 'incrementAdClicks',
                parameters: {
                    'adId': payload.adId,
                }
            });
        }
    },
    fetchAnonymousAdvertisement({ commit, state }) {
        const language = (navigator.languages[0].split('-')[0] === "fr" || navigator.languages[0].split('-')[0] === "en") ? navigator.languages[0].split('-')[0] : "en";
        let url;
        if (location.hostname !== "localhost")
            url = "https://europe-west3-socialdiese.cloudfunctions.net/apiUnAuth?name=retrieveRandomAd&parameters[language]="+language;
        else
            url = "http://localhost:5001/socialdiese/europe-west3/apiUnAuth?name=retrieveRandomAd&parameters[language]="+language;
        axios.get(url)
            .then((response) => {
                commit('setAnnouncementsAnonymous', response.data);
                commit('setAnnouncementsAnonymousLoaded', true);
            })
            .catch((e) => console.log("error"));
    },
}

const mutations = {
    setAnnouncements(state, val) {
        state.announcements = val
    },
    setAnnouncementsLoaded(state, val) {
        state.announcementsLoaded = val
    },
    setAnnouncementsAnonymous(state, val) {
        state.announcementsAnonymous = val
    },
    setAnnouncementsAnonymousLoaded(state, val) {
        state.announcementsAnonymousLoaded = val
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/global/announcements.js